import React, { useEffect, useState } from "react";
import {  Col,  Form,  Input,  Modal, theme,  Row,  Divider,} from "antd";
import { PATCH, POST } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";

export default function ShippingModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessage, setErrorMessage] = useState(null);

  const { TextArea } = Input;

  useEffect(() => {
    if (target) {
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  }, [open]);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessage(null);
    try {
      const data = await form.validateFields();
      if (target?.id) {
        await PATCH(`${URL_SETTING.BUYER}${target.id}/`, data);
        onUpdate();
      } else {
        await POST(URL_SETTING.BUYER, data);
        onUpdate();
      }
    } catch (error) {
      setErrorMessage(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessage(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขลูกค้า" : "เพิ่มลูกค้า"}
      width={550}
      onOk={handleOK}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessage} />

      <Form form={form} layout="vertical">
        <Row
          gutter={16}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Col span={8}>
            <Form.Item
              label="รหัส (Code)"
              name="code"
              rules={[{ required: true, message: "กรุณากรอก Code" }]}
            >
              <Input placeholder="กรอกรหัส" allowClear />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              label="ชื่อลูกค้า"
              name="name"
              rules={[{ required: true, message: "กรุณากรอกชื่อลูกค้า" }]}
            >
              <Input placeholder="กรอกชื่อลูกค้า" allowClear />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="ที่อยู่"
              name="address"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="ที่อยู่"/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Email" name="email" rules={[{ required: false }]}>
              <Input placeholder="Email"/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="หมายเหตุ"
              name="note"
              rules={[{ required: false }]}
            >
              <TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="หมายเหตุ"/>
            </Form.Item>
          </Col>
          <Divider>ข้อมูลผู้ติดต่อ</Divider>
          <Col span={16}>
            <Form.Item
              label="ชื่อผู้ติดต่อ"
              name="contact"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input placeholder="ชื่อผู้ติดต่อ"/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="เบอร์โทรศัพท์"
              name="phone"
            >
              <Input placeholder="เบอร์โทรศัพท์"/>
            </Form.Item>
            <Form.Item
              name="types"
              initialValue={["skim"]}
              style={{ display: "none" }}
            >
              <Input value="skim" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
